import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../common/components/spinner/Spinner';

const LoaderComponent = memo(({ loadingIndicator = false }) => {
    // Early return for better performance
    if (!loadingIndicator) {
        return null;
    }
    
    return <Spinner />;
});

// Display name for debugging
LoaderComponent.displayName = 'LoaderComponent';

// PropTypes for type checking and documentation
LoaderComponent.propTypes = {
    loadingIndicator: PropTypes.bool
};

export default LoaderComponent;